module.exports = __webpack_public_path__ + "media/home-bg-video.8e142b00.mp4";